/**
 * @author Hiroki Moto
 * @description https://marvelapp.com/1152g05j/screen/67851869
 */

import React from 'react';
import Avatar from '@components/@core/Avatar';
import { convertUrl } from '~/services/util';

const Others = ({ data, onDetail, logo }) => (
    <>
        <p className="dsl-b24 bold">Other Products</p>
        {data?.map((item) => (
            <div className="d-flex align-items-center pt-2 pb-2" key={`p${item.id}`} onClick={() => onDetail(item)}>
                <Avatar url={convertUrl(logo, '/images/default_company.svg')} type="logo" />
                <div className="ml-3">
                    <p className="dsl-b14 mb-1">{item.name}</p>
                    <p className="dsl-m12 mb-0">
                        {Math.round(item.stats?.rating_recommended_avg * 100) / 100}% Recommended {item.stats?.rating_count} Ratings
                    </p>
                </div>
            </div>
        ))}
    </>
);

export default Others;
